export const DASHBOARD_URL =
  (import.meta.env.VITE_APP_DASHBOARD_URL as string) || "https://app.swissez.ch";

export const SITE_URL =
  (import.meta.env.VITE_SITE_URL as string) || "https://swissez.ch";
